<template>
    <div class="tile">
        <div class="tile-title">
            <h2>Organization</h2>
        </div>
        <div class="tile-content">
            <ul class="list list-group">
                <li v-fs-block class="list-item">
                    <v-icon icon="company" class="no-flex inline-s"/>{{organizationIdLabel}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import _ from '@/common/helpers';
    import {vIcon} from '@/components/form';
    import vRepeater from '@/components/repeater/repeater';
    import OrganizationModel from '@/common/models/organization-model';
    import detailsMixins from './details-mixins';

    export default {
        name: 'organization',
        mixins: [detailsMixins],
        components: {vIcon, vRepeater},
        props: {
            gateway: {
                type: Object,
                required: true,
            },
        },
        computed: {
            organizationIdLabel() {
                const truncatedId = _.truncate(this.gateway.organizationId, {dots: true});
                if (this.organization) {
                    return `${this.organization.name} (${truncatedId})`;
                }
                return truncatedId;
            },
        },
        data() {
            return {
                organization: null,
            };
        },
        methods: {
            async fetchInfo() {
                try {
                    this.$startLoading('organization');
                    const {fields} = await this.$api(({companies}) => companies.get({id: this.gateway.organizationId}));
                    this.organization = new OrganizationModel(fields);
                } catch (error) {
                    this.$toast.fromError(error, `Couldn't retrieve organization. Please contact support`);
                } finally {
                    this.$stopLoading('organization');
                }
            },
        },
        created() {
            this.fetchInfo();
        },
    };
</script>
